export interface SoundDefinition {
  readonly id: string;
  readonly name: string;
  readonly offset: number;
  readonly duration: number;
  readonly colorClass: string;
}

export const SOUND_DEFINITIONS: readonly SoundDefinition[] = [
  { id: "cowbell", name: "Cowbell", offset: 0, duration: 0.3, colorClass: "bg-sound-cowbell" },
  {
    id: "conga_hi",
    name: "High Conga",
    offset: 0.4,
    duration: 0.3,
    colorClass: "bg-sound-conga-hi",
  },
  { id: "cymbal", name: "Cymbal", offset: 0.807, duration: 3.64, colorClass: "bg-sound-cymbal" },
  {
    id: "conga_mid",
    name: "Mid Conga",
    offset: 4.455,
    duration: 0.202,
    colorClass: "bg-sound-conga-mid",
  },
  {
    id: "conga_low",
    name: "Low Conga",
    offset: 4.863,
    duration: 0.343,
    colorClass: "bg-sound-conga-low",
  },
  {
    id: "hihat_open",
    name: "Open Hi-Hat",
    offset: 5.268,
    duration: 0.706,
    colorClass: "bg-sound-hihat-open",
  },
  { id: "tom_hi", name: "High Tom", offset: 6.277, duration: 0.206, colorClass: "bg-sound-tom-hi" },
  {
    id: "maracas",
    name: "Maracas",
    offset: 6.684,
    duration: 0.053,
    colorClass: "bg-sound-maracas",
  },
  {
    id: "tom_mid",
    name: "Mid Tom",
    offset: 7.092,
    duration: 0.263,
    colorClass: "bg-sound-tom-mid",
  },
  {
    id: "hihat_closed",
    name: "Closed Hi-Hat",
    offset: 7.496,
    duration: 0.09,
    colorClass: "bg-sound-hihat-closed",
  },
  { id: "tom_low", name: "Low Tom", offset: 7.903, duration: 0.37, colorClass: "bg-sound-tom-low" },
  { id: "clave", name: "Clave", offset: 8.307, duration: 0.044, colorClass: "bg-sound-clave" },
  { id: "clap", name: "Clap", offset: 8.712, duration: 0.208, colorClass: "bg-sound-clap" },
  { id: "snare", name: "Snare", offset: 9.116, duration: 0.137, colorClass: "bg-sound-snare" },
  { id: "rim", name: "Rimshot", offset: 9.521, duration: 0.036, colorClass: "bg-sound-rim" },
  { id: "kick", name: "Kick", offset: 9.929, duration: 0.39, colorClass: "bg-sound-kick" },
] as const;

export default SOUND_DEFINITIONS;
